import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToCommonPacksPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate to={generateSportContextPath(ANY_SPORT_SERIES_MARKET)} replace />
  );
};
export default RedirectToCommonPacksPage;
